<ng-container *ngIf="(legalNoticeObservable | async) as legalInfo;">

    <ng-container *ngIf="legalInfo.available">

        <div class="disclaimer-link">
            <i class="icon-disclaimer"></i>

            <ng-container *ngIf="legalInfo.disclaimer">
                <a routerLink="legal-notice/disclaimer">
                    <span [innerHTML]="legalInfo.disclaimer | translate"></span>
                </a>
            </ng-container>
            <ng-container *ngIf="legalInfo.privacy_policy">
                <a routerLink="legal-notice/privacy-policy">
                    <span [innerHTML]="legalInfo.privacy_policy | translate"></span>
                </a>
            </ng-container>

        </div>

    </ng-container>

</ng-container>


<!--<ng-container *ngIf="ready && (disclaimer || privacyPolicy)">-->
<!--    <div class="disclaimer-link">-->
<!--        <i class="icon-disclaimer"></i>-->
<!--        <ng-container *ngIf="disclaimer">-->
<!--            <a routerLink="legal-notice/disclaimer">-->
<!--                <span [innerHTML]="disclaimer | translate"></span>-->
<!--            </a>-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="privacyPolicy">-->
<!--            <a routerLink="legal-notice/privacy-policy">-->
<!--                <span [innerHTML]="privacyPolicy | translate"></span>-->
<!--            </a>-->
<!--        </ng-container>-->
<!--    </div>-->
<!--</ng-container>-->

<!--play-audio-->
<!--onEnterSound="btn_default_enter"-->
<!--onClickSound="btn_default_click"-->

<!--play-audio-->
<!--onEnterSound="btn_default_enter"-->
<!--onClickSound="btn_default_click"-->